import {
    GET_REPORT_OPTIONS,
    GET_REPORT_OPTIONS_SUCCESS,
    GET_REPORT_OPTIONS_FAILED,
    GET_REPORT,
    GET_REPORT_SUCCESS,
    GET_REPORT_FAILED
} from './actionTypes';

export const getReportOption = () => {
    return {
        type: GET_REPORT_OPTIONS
    }
}
export const getReportOptionSuccess = (reportOptions) => {
    return {
        type: GET_REPORT_OPTIONS_SUCCESS,
        payload: reportOptions
    }
}

export const getReportOptionFailed= () => {
    return {
        type: GET_REPORT_OPTIONS_FAILED
    }
}

export const getReport = (page) => {
    return {
        type: GET_REPORT,
        payload: page
    }
}

export const getReportSuccess = (data) => {
    return {
        type: GET_REPORT_SUCCESS,
        payload: data
    }
}

export const getReportFailed= () => {
    return {
        type: GET_REPORT_FAILED
    }
}
